<template>
    <div>
      <div class="success-container">
        <div class="success-wrapper">
          <div class="success-header">
            <div class=" column100 flex-space-between items-center">
              <div class="success-header__icon">
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF"/>
                <path d="M23.5 28L26.5 31L32.5 25M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z" stroke="#039855" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="4" y="4" width="48" height="48" rx="24" stroke="#ECFDF3" stroke-width="8"/>
                </svg>
            </div>
              <div>
              </div>
              <div
              class="success-header__btn-close cursor-pointer"
              @click="closeModal"
              >
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div class="text-bold text-18 text-center">Telah Diajukan</div>
        </div>
        <div class="success-content text-14">
              <div>
                {{ modalText }}
              </div>
              <div class="btn-submit-success">
                <button class="btn-submit" @click="closeModal">OK</button>
              </div>
            
            
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    props: {
    modalText: {
      type: String,
      required: true
    }
  },
    data() {
      return {
        // selectedOption: '',

      }
      },
      methods: {
        closeModal() {
          this.$emit('closeModalSuccess');
        }
      }
  }
  </script>